var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 18.0547C27.5078 18.6016 28.2188 19.9688 27.8359 21.3359L26.6875 26.3125C26.4688 27.625 25.3203 28.5 23.9531 28.5C10.7188 28.5 0 17.7812 0 4.54688C0 3.17969 0.875 2.03125 2.1875 1.75781L7.16406 0.609375C8.53125 0.28125 9.89844 0.992188 10.4453 2.25L12.7969 7.71875C13.2891 8.86719 12.9062 10.2344 11.9766 11.0547L10.1172 12.5312C11.5391 14.9375 13.5625 16.9609 16.0234 18.3828L17.5 16.5781C18.3203 15.5938 19.6875 15.2109 20.8906 15.7578L26.25 18.0547ZM25.3203 20.7344C25.375 20.625 25.3203 20.5156 25.2109 20.4062L19.8516 18.1094C19.7422 18.0547 19.6328 18.1094 19.5781 18.1641L17.3906 20.8438C17.0078 21.3359 16.2969 21.4453 15.75 21.1719C12.0859 19.3672 9.07812 16.3594 7.27344 12.6953C7 12.1484 7.16406 11.4922 7.60156 11.1094L10.2812 8.92188C10.3906 8.86719 10.3906 8.75781 10.3359 8.64844L8.03906 3.28906C7.98438 3.23438 7.92969 3.125 7.82031 3.125L7.76562 3.17969L2.78906 4.32812C2.67969 4.32812 2.57031 4.4375 2.57031 4.54688C2.57031 16.3047 12.1953 25.875 23.9531 25.875C24.0625 25.875 24.1719 25.7656 24.1719 25.7109L25.3203 20.7344Z",
    fill: "#25272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c14d1f11e7f586a92d441b12973e8f63.svg";
export { ForwardRef as ReactComponent };